// extracted by mini-css-extract-plugin
export var closeButton = "_c7-1";
export var closeX = "_c7-3";
export var container = "_c7-0";
export var image = "_c7-2";